import { DialogModule } from "./story";
import { defaultInitialStep } from "../consts";
import { characterId, storySchema, testStepsNavigation } from "./story";

export const isStoryValid = (story: DialogModule): boolean => {
  return storySchema.isValidSync(story);
}

export const getValidationError = (story: DialogModule): Error | undefined => {
  if (isStoryValid(story)) {
    return undefined;
  }
  
  try {
    storySchema.validateSync(story);
    // should never get here
    return undefined;
  } catch(e: any) {
    return e as Error;
  }
}

export const validateNavigation = (story: DialogModule) => {
  return testStepsNavigation(story.initialStep).validateSync(story.steps);
}

export const isCharacterdIdValid = (possiblyCharId: string): boolean => {
  return characterId.isValidSync(possiblyCharId);
}

export const isStoryBroken = (story: DialogModule): boolean => {
  try {
    if (Object.keys(story).length < 8) {
      return true;
    }   
    if (Object.keys(story.characters).length !== 3) {
      return true;
    }
    if (story.initialStep === defaultInitialStep) {
      return true;
    } 
    return false;
  } catch {
    return true;
  }
}
